export const reportsTutorialSteps = [
  {
    target: '#monitor-global-header',
    title: 'Centro de reportes',
    content: 'Desde acá revisás historial, balance general y reglas de liquidación sin salir del módulo.',
    narration: 'Desde acá revisás historial, balance general y reglas de liquidación sin salir del módulo.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '#route-monitor-tabs',
    title: 'Secciones del módulo',
    content: 'Estas pestañas separan la lectura histórica, el balance consolidado y la configuración económica.',
    narration: 'Estas pestañas separan la lectura histórica, el balance consolidado y la configuración económica.',
    placement: 'bottom',
  },
  {
    target: '#route-monitor-content',
    title: 'Panel de trabajo',
    content: 'Acá cambia el contenido según la sección que tengas abierta, sin perder el hilo del mismo módulo.',
    narration: 'Acá cambia el contenido según la sección que tengas abierta, sin perder el hilo del mismo módulo.',
    placement: 'top',
  },
  {
    target: '#route-monitor-tabs',
    title: 'Cómo leerlo rápido',
    content: 'Primero revisá historial, después balance, y por último reglas si necesitás ajustar criterios o liquidación.',
    narration: 'Primero revisá historial, después balance, y por último reglas si necesitás ajustar criterios o liquidación.',
    placement: 'bottom',
  },
];

export default reportsTutorialSteps;
